/* The White Rabbit – QR-Landingpage. Gehoert zu sections/white-rabbit-landing.liquid */
(function () {
  'use strict';
  var EGGS = ['flasche', 'grinsen', 'tasse', 'schluessel', 'uhr', 'flamingo'];
  var KEY = 'wr-eggs';
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function all(sel, el) { return Array.prototype.slice.call(el.querySelectorAll(sel)); }
  function one(sel, el) { return el.querySelector(sel); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function pop(el, cls) { if (!el || reduce) return; el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls); }

  /* Berlin-Zeit ohne Bibliothek: Sommerzeit vom letzten Sonntag im Maerz bis zum letzten Sonntag im Oktober, jeweils 01:00 UTC */
  function lastSunday(y, m) { var d = new Date(Date.UTC(y, m + 1, 0)); return d.getUTCDate() - d.getUTCDay(); }
  function isDst(ms) { var y = new Date(ms).getUTCFullYear(); return ms >= Date.UTC(y, 2, lastSunday(y, 2), 1) && ms < Date.UTC(y, 9, lastSunday(y, 9), 1); }
  function berlinToUtc(y, m, d, h, mi) { var t = Date.UTC(y, m, d, h || 0, mi || 0) - 36e5; return isDst(t) ? t - 36e5 : t; }
  function berlinNow(ms) { var d = new Date(ms + (isDst(ms) ? 72e5 : 36e5)); return { y: d.getUTCFullYear(), h: d.getUTCHours(), mi: d.getUTCMinutes(), s: d.getUTCSeconds() }; }
  /* Ostersonntag (gregorianisch): [Monat ab 0, Tag] */
  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4,
      f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30,
      i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
      n = h + l - 7 * m + 114;
    return [Math.floor(n / 31) - 1, n % 31 + 1];
  }
  function split(ms) {
    var r = Math.max(0, ms), d = Math.floor(r / 864e5); r -= d * 864e5;
    var h = Math.floor(r / 36e5); r -= h * 36e5;
    var mi = Math.floor(r / 6e4); r -= mi * 6e4;
    return [String(d), pad(h), pad(mi), pad(Math.floor(r / 1e3))];
  }
  function setCount(box, parts) { if (box) all('b', box).forEach(function (b, i) { b.textContent = parts[i]; }); }

  function fileSvg(svg) {
    return '<?xml version="1.0" encoding="UTF-8"?>\n' + svg
      .replace('<svg class="wr-mandala" xmlns="http://www.w3.org/2000/svg"', '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="210mm" height="297mm"')
      .replace(/<use href="/g, '<use xlink:href="');
  }
  function downloadSvg(svg) {
    var blob = new Blob([fileSvg(svg)], { type: 'image/svg+xml' });
    var url = URL.createObjectURL(blob), a = document.createElement('a');
    a.href = url; a.download = 'kaninchenbau-ausmalbild.svg';
    document.body.appendChild(a); a.click();
    setTimeout(function () { URL.revokeObjectURL(url); a.parentNode.removeChild(a); }, 1500);
  }
  function printSvg(svg) {
    var w = window.open('', '_blank');
    if (!w) return false;
    w.document.open();
    w.document.write('<!doctype html><html lang="de"><head><meta charset="utf-8"><title>Ausmalbild: Ab in den Kaninchenbau!</title><style>@page{size:A4;margin:0}html,body{margin:0;background:#fff}svg{display:block;width:210mm;height:297mm;max-width:100%}</style></head><body>' + svg + '<script>window.onload=function(){setTimeout(function(){window.print()},300)}<\/script></body></html>');
    w.document.close();
    return true;
  }

  function init(root) {
    if (root.getAttribute('data-wr-ready')) return;
    root.setAttribute('data-wr-ready', '1');
    var live = one('[data-wr-live]', root);
    function say(t) { if (!live || !t) return; live.textContent = ''; setTimeout(function () { live.textContent = t; }, 60); }

    /* Ostereiersuche: sechs unmoegliche Dinge, gemerkt im Browser */
    var found = [];
    try { found = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { found = []; }
    if (!Array.isArray(found)) found = [];
    found = found.filter(function (x) { return EGGS.indexOf(x) > -1; });
    function renderEggs(fresh) {
      var n = found.length, done = n >= EGGS.length;
      all('[data-egg]', root).forEach(function (b) { b.classList.toggle('is-found', found.indexOf(b.getAttribute('data-egg')) > -1); });
      all('[data-egg-pill]', root).forEach(function (p) {
        var id = p.getAttribute('data-egg-pill'), on = found.indexOf(id) > -1;
        p.classList.toggle('is-found', on);
        one('[data-when="hidden"]', p).hidden = on;
        one('[data-when="found"]', p).hidden = !on;
        if (on && id === fresh) pop(p, 'wr-pop');
      });
      all('[data-egg-count]', root).forEach(function (c) { c.textContent = n; });
      all('[data-eggs-done]', root).forEach(function (el) { el.hidden = !done; });
      all('[data-eggs-open]', root).forEach(function (el) { el.hidden = done; });
      all('[data-egg-input]', root).forEach(function (inp) { inp.value = n + '/' + EGGS.length; });
    }
    all('[data-egg]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var id = b.getAttribute('data-egg');
        if (found.indexOf(id) < 0) {
          found.push(id);
          try { localStorage.setItem(KEY, JSON.stringify(found)); } catch (e) {}
        }
        renderEggs(id);
        var msg = one('[data-egg-pill="' + id + '"] [data-when="found"]', root);
        say(msg ? (msg.innerText || msg.textContent).replace(/\s+/g, ' ').trim() : '');
      });
    });
    renderEggs();

    /* Welche Tuete hast du? */
    all('[data-bag]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var v = b.getAttribute('data-bag');
        all('[data-bag]', root).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        all('[data-recipe]', root).forEach(function (r) { r.hidden = r.getAttribute('data-recipe') !== v; });
      });
    });

    /* Hinter den Spiegeln */
    var cards = all('[data-flip]', root);
    function flip(card, on) {
      card.setAttribute('aria-pressed', on ? 'true' : 'false');
      var fr = one('.wr-mfront', card), bk = one('.wr-mback', card);
      if (fr.hidden === on && bk.hidden === !on) return;
      fr.hidden = on; bk.hidden = !on;
      pop(on ? bk : fr, 'wr-flip');
    }
    cards.forEach(function (c) { c.addEventListener('click', function () { flip(c, c.getAttribute('aria-pressed') !== 'true'); }); });
    var flipAll = one('[data-flip-all]', root), flipReset = one('[data-flip-reset]', root);
    if (flipAll) flipAll.addEventListener('click', function () { cards.forEach(function (c) { flip(c, true); }); });
    if (flipReset) flipReset.addEventListener('click', function () { cards.forEach(function (c) { flip(c, false); }); });

    /* Die tolle Kaffeegesellschaft */
    var table = one('[data-table]', root);
    if (table) {
      var chips = all('.wr-chip', table), seats = all('[data-seat]', root), turns = 0;
      var storyBtn = one('[data-story]', root), story = one('[data-story-card]', root);
      var showSeat = function (animate) {
        var idx = turns % chips.length;
        table.style.setProperty('--rot', (-turns * 360 / chips.length) + 'deg');
        chips.forEach(function (c, i) { c.classList.toggle('is-active', i === idx); });
        seats.forEach(function (s, i) { s.hidden = i !== idx; if (i === idx && animate) pop(s, 'wr-fade'); });
        var cur = seats[idx];
        if (story && cur) {
          one('[data-story-name]', story).textContent = one('h3', cur).textContent;
          one('[data-story-drink]', story).textContent = one('.wr-drink', cur).textContent;
        }
        return cur;
      };
      var next = one('[data-next]', root);
      if (next) next.addEventListener('click', function () { turns++; var cur = showSeat(true); if (cur) say(one('h3', cur).textContent); });
      if (storyBtn && story) {
        storyBtn.addEventListener('click', function () {
          var open = story.hidden;
          story.hidden = !open;
          storyBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
          one('[data-label-open]', storyBtn).hidden = open;
          one('[data-label-close]', storyBtn).hidden = !open;
          if (open) pop(story, 'wr-fade');
        });
      }
      showSeat(false);
    }

    /* Glaeser im Regal: lange Woerter verkleinern statt mitten im Wort umbrechen */
    function fitLabels() {
      all('.wr-label', root).forEach(function (l) {
        var size = 9; l.style.fontSize = '';
        while (l.scrollWidth > l.clientWidth + 1 && size > 6) { size -= 0.5; l.style.fontSize = size + 'px'; }
      });
    }
    fitLabels();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitLabels);

    /* Tiefenmesser und Woerterbuch */
    function group(btnSel, panelSel) {
      var btns = all(btnSel, root), panels = all(panelSel, root);
      btns.forEach(function (b, i) {
        b.addEventListener('click', function () {
          btns.forEach(function (x, j) { x.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
          panels.forEach(function (p, j) { p.hidden = j !== i; if (j === i) pop(p, 'wr-fade'); });
        });
      });
    }
    group('[data-level]', '[data-level-tip]');
    group('[data-term]', '[data-term-text]');

    /* Raetsel des Hutmachers */
    var riddle = one('[data-riddle]', root), answer = one('[data-answer]', root);
    if (riddle && answer) {
      riddle.addEventListener('click', function () {
        answer.hidden = false; riddle.hidden = true; pop(answer, 'wr-fade');
        answer.setAttribute('tabindex', '-1'); answer.focus();
      });
    }

    /* Ausmalbild */
    var holder = one('[data-mandala]', root);
    if (holder) {
      var svg = window.wrMandala ? window.wrMandala() : '';
      if (svg) holder.innerHTML = svg;
      var pb = one('[data-print]', root), db = one('[data-download]', root);
      if (svg && pb) pb.addEventListener('click', function () { if (!printSvg(svg)) downloadSvg(svg); });
      if (svg && db) db.addEventListener('click', function () { downloadSvg(svg); });
    }

    /* Uhren, Countdown bis Ostern und bis Teilnahmeschluss */
    var hero = { h: one('[data-hand="h"]', root), m: one('[data-hand="m"]', root), s: one('[data-hand="s"]', root) };
    var raffle = one('[data-raffle]', root), clock = raffle ? one('.wr-clock', raffle) : null;
    var rh = clock ? { h: one('[data-rhand="h"]', clock), m: one('[data-rhand="m"]', clock), s: one('[data-rhand="s"]', clock) } : null;
    var wonder = false, raffleEnd = null, ry = null;
    var mEnd = raffle ? String(raffle.getAttribute('data-end') || '').match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/) : null;
    if (mEnd) { ry = +mEnd[1]; raffleEnd = berlinToUtc(ry, +mEnd[2] - 1, +mEnd[3], +mEnd[4], +mEnd[5]) + 6e4; }
    var dstNote = one('[data-dst-note]', root);
    if (dstNote && ry) {
      var re = easter(ry);
      if (re[0] === 2 && re[1] === lastSunday(ry, 2)) {
        dstNote.hidden = false;
        all('[data-dst-year]', dstNote).forEach(function (s) { s.textContent = ry; });
      }
    }
    function turn(el, deg, cx, cy) { if (el) el.setAttribute('transform', 'rotate(' + deg + ' ' + cx + ' ' + cy + ')'); }
    function tick() {
      var now = Date.now(), b = berlinNow(now);
      var hd = (b.h % 12) * 30 + b.mi * 0.5, md = b.mi * 6 + b.s * 0.1, sd = b.s * 6;
      turn(hero.h, hd, 150, 190); turn(hero.m, md, 150, 190); turn(hero.s, sd, 150, 190);
      var y = b.y, e = easter(y), start = berlinToUtc(y, e[0], e[1], 0, 0), stop = berlinToUtc(y, e[0], e[1] + 2, 0, 0);
      if (now >= stop) { y++; e = easter(y); start = berlinToUtc(y, e[0], e[1], 0, 0); }
      var before = now < start;
      all('[data-easter="before"]', root).forEach(function (el) { el.hidden = !before; });
      all('[data-easter="during"]', root).forEach(function (el) { el.hidden = before; });
      setCount(one('[data-count="easter"]', root), split(start - now));
      if (rh) {
        rh.h.style.transform = 'rotate(' + (wonder ? 180 : hd) + 'deg)';
        rh.m.style.transform = 'rotate(' + (wonder ? 0 : md) + 'deg)';
        rh.s.style.transform = 'rotate(' + sd + 'deg)';
      }
      if (raffleEnd) {
        var open = now < raffleEnd;
        all('[data-raffle-open]', root).forEach(function (el) { el.hidden = !open; });
        all('[data-raffle-closed]', root).forEach(function (el) { el.hidden = open; });
        setCount(one('[data-count="raffle"]', root), split(raffleEnd - now));
      }
    }
    all('[data-mode]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        wonder = btn.getAttribute('data-mode') === 'wonder';
        all('[data-mode]', root).forEach(function (x) { x.setAttribute('aria-pressed', x === btn ? 'true' : 'false'); });
        if (clock) {
          clock.classList.add('wr-anim');
          setTimeout(function () { clock.classList.remove('wr-anim'); }, 700);
          clock.setAttribute('aria-label', wonder ? 'Uhr in Wunderland-Zeit: sechs Uhr' : 'Uhr in Berlin-Zeit');
        }
        if (rh && rh.s) rh.s.style.display = wonder ? 'none' : '';
        all('[data-caption]', root).forEach(function (c) { c.hidden = c.getAttribute('data-caption') !== (wonder ? 'wonder' : 'berlin'); });
        tick();
      });
    });
    tick();
    setInterval(tick, 1000);
  }

  function boot(scope) { all('[data-wr]', scope || document).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (ev) { boot(ev.target); });
})();